<template lang="pug">
  .text-center.neutral700--text
    v-icon.mb-5(size="55" color="success500") $yzi-ticket-01
    template(v-if="customer && selectedOffer")
      .text-md.font-semibold.mb-4 {{ customer.name }} has applied an offer!
      y-chip.round-xl.pa-4.info.d-block.mb-4
        .d-flex
          v-icon(color="info500") $yzi-gift-02
          .text-left.ml-3
            .text-sm.font-semibold {{ selectedOffer.offer.name }}
            .text-sm {{ selectedOffer.code }}
      y-chip.round-xl.d-block.pa-4(outlined)
        v-row.align-center.mb-2(no-gutters)
          v-col(cols="4")
            .text-sm.text-left Customer:
          v-col
            .text-sm.text-left.font-semibold {{ customer.name }}
        v-row.align-center(no-gutters)
          v-col(cols="4")
            .text-sm.text-left Phone number:
          v-col
            .text-sm.text-left.font-semibold +{{ customer.phone }}
    template(v-else)
      v-skeleton-loader(type="list-item-two-line@3")
</template>

<script>

export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
    selectedOffer: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.info {
  background-color: #E4F2FF !important
}
</style>